import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { injectIntl, intlShape } from 'react-intl';

import Flag from '@xingternal/malt-flag';
import SelectList, { asSelectListOption } from '@xingternal/malt-select-list';
import { TrackedLink, withTracking } from '../xing-tracking';
import trackings from '../trackings';

import styles from './index.css';

const Link = withTracking(trackings)(({ children, ...props }) => {
  return (
    <TrackedLink {...{ ...props, trackingKey: 'header' }}>
      {children}
    </TrackedLink>
  );
});

const SelectListLink = asSelectListOption(Link);

const SettingsDropdownList = ({ intl: { formatMessage }, links }) => {
  const ListItems = links.map(function(linkItem) {
    const LinkIconElement = linkItem.iconOdl || null;
    const LinkHoveredIconElement = linkItem.activeIconOdl || null;
    const linkClasses = classNames(styles.item, {
      [styles.highlighted]: linkItem.highlighted,
    });

    const title = formatMessage({ id: linkItem.title });
    return (
      <SelectListLink
        key={linkItem.key}
        className={linkClasses}
        href={linkItem.href}
      >
        <span className={styles.itemText}>{title}</span>

        {linkItem.flag && <Flag className={styles.flag} type={linkItem.flag} />}
        {LinkIconElement && <LinkIconElement className={styles.icon} />}
        {LinkHoveredIconElement && (
          <LinkHoveredIconElement className={styles.iconHovered} />
        )}
      </SelectListLink>
    );
  });

  return <SelectList className={styles.itemList}>{ListItems}</SelectList>;
};

SettingsDropdownList.displayName = 'SettingsDropdownList';

SettingsDropdownList.propTypes = {
  intl: intlShape,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      iconOdl: PropTypes.func,
      activeIconOdl: PropTypes.func,
      highlighted: PropTypes.bool,
      flag: PropTypes.oneOf(['PROMO']),
    })
  ).isRequired,
};

export default injectIntl(SettingsDropdownList);
